import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { supabase } from '@/integrations/supabase/client';
import { LuxuryImageFrame } from '../ui/LuxuryImageFrame';

export function ShowcaseImages() {
  const [rooms, setRooms] = useState<any[]>([]);

  useEffect(() => {
    const fetchRooms = async () => {
      const { data } = await supabase
        .from('rooms')
        .select('*')
        .order('created_at', { ascending: true })
        .limit(2);
      
      if (data) setRooms(data);
    };
    fetchRooms();
  }, []);

  // Fallback data if DB is empty
  const displayRooms = rooms.length > 0 ? rooms : [
    {
      name: "Cozy Room Rentals",
      image_url: "/assets/showcase-bedroom.jpg",
      description: "Enjoy our comfortable rooms, perfect for a peaceful stay amidst nature and tranquility."
    },
    {
      name: "Inviting Open Kitchen",
      image_url: "/assets/showcase-kitchen.jpg",
      description: "Gather and cook together in our spacious open kitchen, ideal for family meals and bonding."
    }
  ];

  return (
    <section id="rooms" className="py-12 bg-secondary px-6">
      <div className="max-w-screen-lg mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {displayRooms.map((room, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white border border-[#B8863B]/10 overflow-hidden group flex flex-col shadow-sm"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={room.image_url}
                  alt={room.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              
              <div className="p-8 md:p-10 flex flex-col flex-grow bg-white">
                <h3 className="text-2xl md:text-3xl font-serif mb-4 !text-[#26352C]">
                  {room.name}
                </h3>
                <div className="w-10 h-[1px] bg-[#B8863B] mb-4" />
                <p className="font-clean text-base leading-relaxed !text-[#59635C]">
                  {room.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
